// extracted by mini-css-extract-plugin
module.exports = {"label":"_15f3de76","tabs":"_ee512f34","border":"_6123f89c"};